import React, { useContext } from "react";
import { Stores, StoresContext } from "Globals/Stores";
import { PrivateRoute } from "Globals/Views/PrivateRoute";
import * as RouterUtil from "Utils/Routing";
import { StoresInstance } from "Globals/Stores";
import { AppUrls } from "../../AppUrls";
//import { ClientDetailView } from "./ClientDetailView";
import { CentralListView } from "./CentralListView";
import { DarwinLayout } from "Globals/Views/Layouts/DarwinLayout";

export const CentralRoutes: React.FC = () => {
    function getRootLayout() {
        return DarwinLayout;
    }

    const store = useContext<Stores>(StoresContext);
    return (
        <>
            <PrivateRoute
                exact
                path={AppUrls.Client.Central.View}
                component={CentralListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && store.Domain.AccountStore.getCanViewCentralProject && RouterUtil.requireNotSiteManagerLoggedIn(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            {/* <PrivateRoute
                exact
                path={AppUrls.Client.Central.List}
                component={CentralListView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            /> */}
            {/* <PrivateRoute
                exact
                path={AppUrls.Client.Central.Detail}
                component={CentralDetailView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            />
            <PrivateRoute
                exact
                path={AppUrls.Client.Central.Edit}
                component={CentralDetailView}
                isAllowed={() => {
                    return store.Domain.AccountStore.IsLoggedIn && RouterUtil.requireAdminLogin(StoresInstance);
                }}
                layout={getRootLayout()}
            /> */}
        </>
    );
};
